import workflow from '@banking/ui/lib/workflow';
import { update } from './update';
export { StateSelector, StateType, createState } from './state';
export { Action, ActionCreator, InitializationType } from './action';
export { update, HIDE_CHECK_EDUCATION_LOCAL_STORAGE_KEY } from './update';
export default (context, initialState) => workflow(update(context), initialState);